<template>
  <panel :title="detailsTask" :withBody="false" :withFooter="false" :to="{ name: 'tokenEdit', params: { identifier: token._id.$oid } }">
    <div slot="header-right">
      <span v-bind:class="{success: token.status, error: !token.status}" class="badge">{{ $t(`token.status.${token.status}.label`) }}</span>
    </div>
  </panel>
</template>

<script>
  import Panel from '@/components/template/Panel'

  export default {
    props: {
      token: {
        type: Object,
        required: true
      }
    },
    computed: {
      detailsTask () {
        return `${this.token.description} (${this.token.authorization})`
      }
    },
    components: {
      Panel
    }
  }
</script>

<style lang="sass"scoped>

</style>



// WEBPACK FOOTER //
// TokenCard.vue?78e25589